import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { persistStorage } from '@/stores/persistStorage';
import type { CalendarEvent, CalendarSource } from '@/types';

export interface CalendarState {
  events: CalendarEvent[];
  lastSyncedAt?: Date;
  setEvents: (events: CalendarEvent[]) => void;
  upsertEvents: (events: CalendarEvent[]) => void;
  clearForSource: (source: CalendarSource) => void;
}

export const useCalendarStore = create<CalendarState>()(
  persist(
    (set) => ({
      events: [],
      setEvents: (events) => set({ events, lastSyncedAt: new Date() }),
      upsertEvents: (events) =>
        set((s) => {
          const byId = new Map(s.events.map((e) => [e.id, e]));
          for (const e of events) byId.set(e.id, e);
          return { events: Array.from(byId.values()), lastSyncedAt: new Date() };
        }),
      clearForSource: (source) =>
        set((s) => ({ events: s.events.filter((e) => e.source !== source) })),
    }),
    { name: 'brainday:calendar', storage: persistStorage<CalendarState>() },
  ),
);
